/**
 * Pre-compiled fr-FR messages for Calendar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  nextMonth: `Mois suivant`,
  nextYear: `Année suivante`,
  previousMonth: `Mois précédent`,
  previousYear: `Année précédente`,
};
